export const TYPE_INITIALIZE = 'Initialize';
